export const FormErrorMessages = {
  'Organisation/Company': 'Please fill in your organization Name',
  'Company Registration Number (CVR)': 'Please fill the CVR',
  'First Name': 'Please fill in your First Name',
  Surname: 'Please fill in your Surname',
  'Street Address': 'Please fill in your address',
  City: 'Please enter your city here.',
  Country: 'Please select the country from the dropdown',
  'ZIP / Postal code': 'Please fill the postal code',
  Phone: 'Please fill your phone number',
  Email: 'Please fill your email address.',
  'Project title': 'Please fill the Project title',
  'Amount applied for': 'Please fill the field',
  'Information on any co-funding': 'Please fill the field',
  Resume: 'Please fill the field',
  Aim: 'Please fill the field',
  Relevance: 'Please fill the field',
  'Target group(s)': 'Please fill the field',
  'Main activities': 'Please fill the field',
  'Expected impact and results': 'Please fill the field',
  'Implementation, anchorage and scaling': 'Please fill the field',
  'Organisational capacity': 'Please fill the field',
  Communication: 'Please fill the field',
  'Collaboration with Ramboll': 'Please fill the field',
  'Involvement of Ramboll employees': 'Please fill the field',
  'Detailed budget': 'Please fill the field',
  'Declaration of consent': 'Please accept the Declaration of consent',
};
